
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createPermission } from "../redux/actions/roleActions";

const CreatePermission = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.role);

  const [permissionName, setPermissionName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!permissionName.trim()) return;

    dispatch(createPermission({ permission_name: permissionName, description }));
    setPermissionName("");
    setDescription("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Permission</h1>

        {error && (
          <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Permission Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Permission Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter permission name"
              value={permissionName}
              onChange={(e) => setPermissionName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Description</label>
            <input
              type="text"
              placeholder="Enter description (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {loading ? "Creating..." : "Create Permission"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreatePermission;
